const $$splitComponentImporter = () => import('/home/runner/work/nexus/nexus/apps/frontend/src/routes/(unauthenticated)/published/v1/swimlane/$linkId/index.tsx?tsr-split=component');
import { lazyRouteComponent } from '@tanstack/react-router';
import { createFileRoute } from '@tanstack/react-router';
import { zodValidator } from '@tanstack/zod-adapter';
import { publishedSwimlaneSearchSchema } from './searchSchema';

/**
 * Main published swimlane route.
 * This is the default public-facing view that renders the complete page
 * with header, footer, legend, and swimlane content.
 *
 * URL: /published/v1/swimlane/{linkId}
 *
 * Query parameters are defined in the shared publishedSwimlaneSearchSchema.
 */
export const Route = createFileRoute('/(unauthenticated)/published/v1/swimlane/$linkId/')({
  component: lazyRouteComponent($$splitComponentImporter, 'component'),
  validateSearch: zodValidator(publishedSwimlaneSearchSchema)
});